export interface ApiRequestHandlerOptions {
    overrideLinks?: ResourceLink[];
    method?: HttpMethodUnion;
    logger?: boolean;
}

export interface ResourceLink {
    context: ResourceLink[];
    href: string;
    rel: string;
    type?: HttpMethodUnion;
}

export interface ExtendedLink {
    url: string;
    method?: HttpMethodUnion;
}

export interface Resource {
    _links: ResourceLink[];
}

export enum HttpMethod {
    GET = 'GET',
    HEAD = 'HEAD',
    POST = 'POST',
    PUT = 'PUT',
    PATCH = 'PATCH',
    DELETE = 'DELETE',
    OPTIONS = 'OPTIONS',
    TRACE = 'TRACE',
}

export type HttpMethodUnion = 'GET' | 'HEAD' | 'POST' | 'PUT' | 'PATCH' | 'DELETE' | 'OPTIONS' | 'TRACE';
